import React from 'react'
import { Box, Skeleton } from '@mui/material'

const SortTabsShimmer = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Skeleton sx={{ flex: 1 }} variant="rectangular" width={80} height={40} />
        <Skeleton sx={{ flex: 1 }} variant="rectangular" width={80} height={40} />
    </Box>
)

export default SortTabsShimmer
